import { apiGet } from "@/lib/api";
import { AGGREGATE } from "@/lib/query-freshness";
import type { NavCountsResponse } from "@/types-nav-counts";

/**
 * How often the sidebar reads its counts again while the console is open. Upstream caches the
 * answer for 30 s, so reading more often than this buys nothing.
 */
export const NAV_COUNTS_REFRESH_MS = 60_000;

/** One read for every area's badge; each badge `select`s its own key. */
export function navCountsQuery() {
  return {
    ...AGGREGATE,
    refetchInterval: NAV_COUNTS_REFRESH_MS,
    queryKey: ["nav-counts"] as const,
    queryFn: () => apiGet<NavCountsResponse>("/api/admin/nav-counts"),
  };
}
